import React, {useState} from "react";
import {Container} from "react-bootstrap";
import PurposeBox from "../../Components/SalesAnalysis/PurposeBox.jsx";
import AnalysisFilterBar from "../../Components/SalesAnalysis/AnalysisFilterBar.jsx";
import DataStatusBar from "../../Components/SalesAnalysis/DataStatusBar.jsx";
import GesamtTable from "../../Components/SalesAnalysis/GesamtTable.jsx";
import KumuliertChart from "../../Components/SalesAnalysis/KumuliertChart.jsx";
import StickyFilterBlock from "../../Components/StickyFilterBlock.jsx";
import {filterZusammenfassung} from "../../Components/SalesAnalysis/format.js";
import useAnalysisFilters from "../../Components/SalesAnalysis/useAnalysisFilters.js";

/**
 * Gesamtsicht der Vertriebsauswertung - Einstiegsseite (/vertrieb → hierher
 * umgeleitet, siehe Backend-Routen). Artikelart × Produktlinie × Jahre mit
 * Drilldown Kontinent → Land → Kunde.
 */
export default function SalesAnalysisGesamt() {
    const filters = useAnalysisFilters();
    const [reloadToken, setReloadToken] = useState(0);
    const effectiveFilters = {...filters, params: {...filters.params, _v: reloadToken}};

    return (
        <Container fluid className="pt-2 pb-4">
            <PurposeBox />
            <h1 className="h4 mb-2">Gesamt</h1>
            {filters.metaError && <div className="alert alert-warning">{filters.metaError}</div>}
            {filters.filtersReady && (
                <>
                    <StickyFilterBlock summary={filterZusammenfassung(filters)}>
                        <AnalysisFilterBar filters={filters} />
                        <DataStatusBar meta={filters.meta} onRecalculated={() => setReloadToken((t) => t + 1)} />
                    </StickyFilterBlock>
                    <KumuliertChart filters={effectiveFilters} />
                    <GesamtTable filters={effectiveFilters} />
                </>
            )}
        </Container>
    );
}
